const config = {
    API_BASE_URL: "https://redemptionapi.onrender.com",
    BASE_URL: "https://norbertloh.github.io/RedemptionUI/"
};

export default config;
